import { AxiosError, AxiosInstance, AxiosResponse, PaginatedResponse } from 'axios'
import { getPropertyFrom } from 'commons/utils/json'
import { showSnackbar } from 'components/Snackbar/actionsSnackbar'
import { parseError } from './utils/messageErrors'
import { tryToRefreshToken } from './utils/refresh'
import { hasSafeErrorStatus } from './utils/safeErrors'

const onResponse = (resp: AxiosResponse) => {
  if (resp.status == 204 && !resp.data) {
    resp.data = []
  }

  if (resp.config.paginated) {
    return {
      data: resp.data,
      totalPages: getPropertyFrom(resp.headers['x-pagination'], 'TotalPages') || 0,
      totalItems:
        getPropertyFrom(resp.headers['x-pagination'], 'TotalItems') ||
        getPropertyFrom(resp.headers['x-pagination'], 'TotalCount') ||
        0,
    } as PaginatedResponse
  }

  return resp.data
}

const onResponseError = (client: AxiosInstance) => (error: AxiosError) => {
  const message: string = error.response?.data?.message ?? ''
  const status = error.response?.status ?? 500

  if (!hasSafeErrorStatus(error)) {
    if (status === 401) return tryToRefreshToken(client, error.config)

    //  status[403] deverá redirecionar para a página forbidden

    showSnackbar('error', parseError(status, error.response))
  }

  return Promise.reject({ ...error, status, message })
}

export { onResponse, onResponseError }
